import { useState } from 'react';
import './LeftMenu.css';
import { iconsRegistry } from '../icons/IconsRegistry';
import { useLocalization } from '@capsplus/mfe-common';

const LeftMenu = ({ menuItems, onMenuClick, isCollapsed, onToggleCollapse }) => {
  const [expandedItems, setExpandedItems] = useState({});
  const { L } = useLocalization();

  const toggleExpanded = (itemId) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  };

  const handleMenuClick = (item, e) => {
    e.stopPropagation();

    if (item.items && item.items.length > 0) {
      // Use item.name instead of item.id for consistency
      toggleExpanded(item.name);
    } else {
      onMenuClick(item);
    }
  };

  const renderMenuItem = (item, level = 0) => {
    const hasChildren = item.items && item.items.length > 0;
    // Use item.name consistently throughout
    const isExpanded = expandedItems[item.name];
    const paddingLeft = level * 16 + 16;
    const IconComponent = iconsRegistry[item.name] || null;

    return (
      <div key={item.name} className="left-menu-item-container">
        <div
          className={`left-menu-item ${hasChildren ? 'has-children' : ''} ${isExpanded ? 'expanded' : ''
            }`}
          style={{ paddingLeft: isCollapsed ? 16 : paddingLeft }}
          onClick={(e) => handleMenuClick(item, e)}
          title={isCollapsed ? item.displayName : ''}
        >
          <span className="left-menu-icon">
            {IconComponent ? <IconComponent /> : ''}
          </span>
          {!isCollapsed && (
            <>
              <span className="left-menu-title">{item.displayName}</span>
              {hasChildren && (
                <span
                  className={`left-menu-arrow ${isExpanded ? 'expanded' : ''}`}
                >
                  ▶
                </span>
              )}
            </>
          )}
        </div>

        {hasChildren && !isCollapsed && (
          <div className={`left-menu-children ${isExpanded ? 'expanded' : ''}`}>
            {item.items.map((child) => renderMenuItem(child, level + 1))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className={`left-menu ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="left-menu-header">
        <button
          className="left-menu-toggle"
          onClick={onToggleCollapse}
          title={isCollapsed ? 'Expand menu' : 'Collapse menu'}
        >
          ☰
        </button>
        {!isCollapsed && (
          <span className="left-menu-header-title">{L('Navigation')}</span>
        )}
      </div>

      <div className="left-menu-content">
        {menuItems.map((item) => renderMenuItem(item))}
      </div>
    </div>
  );
};

export default LeftMenu;
